import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { Scribble } from "@/components/site/Doodles";

export default function NotFound() {
  return (
    <section className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-start justify-center px-4 py-20" data-testid="not-found-page">
      <Seo title="الصفحة مش موجودة" noindex />
      <Scribble className="km-wiggle mb-6 h-24 w-24" />
      <h1 className="font-display text-5xl text-white sm:text-6xl">الصفحة دي اتخربشت!</h1>
      <p className="mt-4 text-purple-200/85">شكلها مش موجودة. ارجع للرئيسية وكمّل.</p>
      <Link to="/" className="font-head mt-8 rounded-full bg-[var(--km-purple)] px-6 py-3 font-bold text-white" data-testid="not-found-home-link">ارجع للرئيسية</Link>
    </section>
  );
}
